import { api } from "./api/api.module";
import { date } from "./date/date.module";
import { location } from "./location/location.module";
import { videoUrl } from "./video-url/video-url.module";
import { imageCrop } from "./image-crop/image-crop.module";
import { fileUpload } from "./file-upload/file-upload.module";
import { ngCkEditor } from "./ng-ckeditor/ng-ckeditor.module";
import { imageUpload } from "./image-upload/image-upload.module";
import { compareObject } from "./compare-object/compare-object.module";

export const libs = angular.module("common.libs", [
  api,
  date,
  location,
  imageCrop,
  fileUpload,
  ngCkEditor,
  imageUpload,
  compareObject,
  videoUrl,
]).name;



// WEBPACK FOOTER //
// ./src/app/common/libs/libs.module.js